export default `<mjml>
  <mj-body>
    <mj-section>
      <mj-column>
        <mj-image src="{header_image}"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column padding="0 20px">
        <mj-text font-weight="bold" font-size="18px">{subject}</mj-text>
        <mj-text>{text}</mj-text>
        <mj-image src="{image}"></mj-image>
        <mj-button background-color="#dbdbdb" font-size="18px" color="black" height="50px" border-radius="30px" href="{click_to_call_button_link}">{click_to_call_button_text}</mj-button>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column background-color="#f8f8f8" padding="15px 0px">
        <mj-text align="center">{footer}</mj-text>
        <mj-text align="center">Para se descadastrar da lista de e-mail, <a href="https://unsubscribe.mercafacil.com/index.html#/?token={{tokenPlaceholder}}&accountId={{accountIdPlaceholder}}">clique aqui</a>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
